import appConfig from 'config/config.app';
import servicesConfig from 'config/config.services';

import defaultConfig from 'config/config.defaults';

const config = {
    ...defaultConfig,
    ...appConfig,
    ...servicesConfig,
};

export default config;
